import { openValuationDateModal } from '../../../State/valuationDateModal'

export default (valuationDate) => (dispatch) => {

  dispatch(openValuationDateModal({ valuationDate }))

}
